import { useParams } from "@tanstack/react-router"

import { MARKET_ITEMS } from "#/shared/constants"
import {
  MarketDonationDetails,
  MarketGiftCardDetails,
  MarketStoreProductDetails,
} from "#/ui/Market"

export default function MarketItemPage() {
  const { marketItemId } = useParams({ strict: false })

  const marketItem = MARKET_ITEMS.find(
    (item) => item.id.toLowerCase() === marketItemId.toLowerCase(),
  )

  if (!marketItem) return null

  if (marketItem.type === "donation") {
    return <MarketDonationDetails donationId={marketItemId} />
  }

  if (marketItem.type === "store-product") {
    return <MarketStoreProductDetails productId={marketItemId} />
  }

  if (marketItem.type === "gift-card") {
    return <MarketGiftCardDetails giftCardId={marketItemId} />
  }

  return null
}
